import { render } from "./cuentaspendientesadm.vue?vue&type=template&id=887b3ac6&scoped=true"
import script from "./cuentaspendientesadm.vue?vue&type=script&lang=js"
export * from "./cuentaspendientesadm.vue?vue&type=script&lang=js"

import "./cuentaspendientesadm.vue?vue&type=style&index=0&id=887b3ac6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887b3ac6"]])

export default __exports__